import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingBag, X } from 'lucide-react';
const notes = [['mx', 'Guadalajara, México', 'María González', 'MG', 'hace 5 minutos'], ['ar', 'Buenos Aires, Argentina', 'Jorge Ramírez', 'JR', 'hace 12 minutos'], ['co', 'Bogotá, Colombia', 'Claudia López', 'CL', 'hace 18 minutos'], ['pe', 'Lima, Perú', 'Valeria Torres', 'VT', 'hace 27 minutos']];
export function PurchaseNotifications() {
  const [index, setIndex] = useState(0);
  const [show, setShow] = useState(false);
  const [closed, setClosed] = useState(false);
  useEffect(() => {
    if (closed) return;
    const start = window.setTimeout(() => setShow(true), 3000);
    return () => clearTimeout(start);
  }, [closed]);
  useEffect(() => {
    if (!show || closed) return;
    const hide = window.setTimeout(() => {
      setShow(false);
      window.setTimeout(() => {
        setIndex(current => (current + 1) % notes.length);
        setShow(true);
      }, 900);
    }, 5000);
    return () => clearTimeout(hide);
  }, [show, closed]);
  if (closed) return null;
  const [flag, city, name, initials, time] = notes[index];
  return <div aria-live="polite" className="pointer-events-none fixed bottom-4 left-1/2 z-50 w-full -translate-x-1/2 px-4" data-id="element-165" data-mp="jui7fdsd4jzw">
      <AnimatePresence mode="wait" data-id="element-166" data-mp="ewgp4v2rgoph">
        {show && <motion.div key={index} initial={{
        opacity: 0,
        y: 35,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20
      }} className="pointer-events-auto mx-auto flex max-w-sm items-center gap-3 rounded-xl border border-slate-200 bg-white p-3.5 shadow-[0_10px_28px_rgba(16,42,67,.16)]" data-id="element-167" data-mp="1cj5w7jcblri7">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[#E7F5EA] text-sm font-bold text-green-dark" data-id="element-168" data-mp="3j9dprqyxsi6a">
              {initials}
            </span>
            <div className="min-w-0 flex-1" data-id="element-169" data-mp="3pqfad9n1ee6m">
              <p className="mb-1 text-[11px] text-slate-500" data-id="element-170" data-mp="3pp46l9tld6fi">
                <img className="mr-1 inline h-3 w-4" src={`https://flagcdn.com/w20/${flag}.png`} alt="" data-id="element-171" data-mp="3atekzcsbivbb" />
                {city}
              </p>
              <p className="text-[13px] leading-snug text-ink" data-id="element-172" data-mp="31zjcpvvwgorg">
                <b className="text-navy" data-id="element-173" data-mp="36rjhq2qtu7uw">{name}</b> compró el Mega Pack Historia
                360
              </p>
              <p className="mt-1 flex items-center gap-1 text-[10px] text-green" data-id="element-174" data-mp="2s2wuleuykbt4">
                <span className="h-1.5 w-1.5 rounded-full bg-green" data-id="element-175" data-mp="2x0otwtxxn07c" />
                <ShoppingBag size={10} data-id="element-176" data-mp="2wyvkx7zuk3w6" />
                Compra verificada · {time}
              </p>
            </div>
            <button type="button" onClick={() => setClosed(true)} className="self-start text-slate-400 hover:text-navy focus-visible:outline focus-visible:outline-green" aria-label="Cerrar notificación" data-id="element-177" data-mp="2n2sn2ec12rf1">
              <X size={15} data-id="element-178" data-mp="1zhq7rgepqo5c" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}